import settingsButton from '../../../../../../assets/icons/settingsButton.svg';
import cls from './SettingsButton.module.scss';

const SettingsButton = () => (
    <button
        className={cls.button}
    >
        {<img src={settingsButton} alt="settingsButton"/>}
    </button>
);
export default SettingsButton;